module.exports = __webpack_public_path__ + "img/arrow-90deg-down.c6b0010e.svg";